import React, { useRef, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import 'video.js/dist/video-js.css';
import BackNavbarLearning from '../../../ReusableBlocks/Navbar'
import Footer from '../../../ReusableBlocks/FooterBlock'
import Modal from 'react-bootstrap/Modal';
import { Link } from "react-router-dom";
import Quiz from './QuizModal';
import LoadingBar from '../../../Images/Animation - 1710409471189.json'
import CryptoJS from 'crypto-js';
import LoadingScreen from '../../../ReusableBlocks/LoadingScreen';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLearningHub, updateVideoStatus } from '../../../Redux/Dashboard/External/LearningHub/LearningHubGetDataAction';
import { fetchLearningHubDetails } from '../../../Redux/Dashboard/External/LearningHub/LearningHubGetDetailsAction';
import ReactPlayer from 'react-player';
import Swal from 'sweetalert2';
import * as PATH from '../../../CentralisedLink'
import { getMediaProvider, normalizeMediaUrl } from '../../../Utils/mediaUrls';


const LearningHubCourse = (props) => {

  const { trackId, microcertId } = useParams();


  const secretKey = 'micro';

  const decryptId = (encryptedId) => {
    const decodedId = decodeURIComponent(encryptedId);
    const bytes = CryptoJS.AES.decrypt(decodedId, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  };


  const encryptId = (id) => {
    const ciphertext = CryptoJS.AES.encrypt(id, secretKey).toString();
    return encodeURIComponent(ciphertext);
  };


  const dispatch = useDispatch();
  const { getData } = useSelector((state) => state.LearningHubData);
  const { loading, getDetails, error } = useSelector((state) => state.LearningHubDetails);


  // Get All Learning Hub Data
  const isLoadingData = useSelector(state => state.LearningHubData?.loading);
  const errorMessageData = useSelector(state => state.LearningHubData?.error);

  // Get Cert Details
  const isLoadingDetails = useSelector(state => state.LearningHubDetails?.loading);
  const errorMessageDetails = useSelector(state => state.LearningHubDetails?.error);

  const videoRef = useRef(null);

  const [includeTrainingVideo, setIncludeTrainingVideo] = useState(false);
  const [includeQuiz, setIncludeQuiz] = useState(false);
  const [screenSize, setScreenSize] = useState('');

  const [showQuizModal, setShowQuizModal] = useState(false);
  const [quizPassed, setQuizPassed] = useState(false); // State to track if the quiz is passed
  const [isQuizPassed, setIsQuizPassed] = useState(false); // Define the state for quiz passed
  const [showWhatsNew, setShowWhatsNew] = useState(false);
  const [fullPageloading, setFullPageLoading] = useState(true);
  const [loadingAnimation, setLoadingAnimation] = useState(LoadingBar);
  const [loadingTitle, setLoadingTitle] = useState("Ingestion In Progress!");
  const [badgde, setbadgde] = useState('');
  const [badgeModel, setBadgdeModel] = useState(false)
  const [playing, setPlaying] = useState(false);

  const handlePlayButtonClick = () => {
    setPlaying(true);
  };

  const handleShowBadgdeModel = () => setBadgdeModel(true);
  const handleCloseBadgdeModel = () => setBadgdeModel(false);
  const handleShowWhatsNew = () => setShowWhatsNew(true);
  const handleCloseWhatsNew = () => setShowWhatsNew(false);


  const url = "https://democoe.s3.us-east-2.amazonaws.com/AIOPs+%26+Observability+(Insta+banking)+-+Presentation+(1).pptx";
  const officeViewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=https://democoe.s3.us-east-2.amazonaws.com/AIOPs%20%26%20Observability%20(Insta%20banking)%20-%20Presentation%20(1).pptx&HideHeaders=True&HideToolbars=True
`;


  useEffect(() => {
    const decryptedId = decryptId(microcertId);
    dispatch(fetchLearningHubDetails(decryptedId));
  }, [dispatch, microcertId]);


  const decryptedId = decryptId(microcertId);
  // Find the track with the matching title
  const track = getData?.tracks.find(t => t.trackTitle === trackId);

  // If the track is found, find the microcert with the matching certId
  const microcert = track?.microcertsList.find(mc => mc.certId === decryptedId);

  const microCertDet = getDetails?.['micro-cert'];


  const AllTracks = getData?.['tracks'];

  const videoStatus = microcert?.videoStatus;
  const quizStatus = microcert?.questionStatus;
  const temporaryCompletionBadge = useSelector((state) => state.temporaryCompletionBadge);

  const completeionBadgde = temporaryCompletionBadge || microcert?.completionBadge;

  // const completeionBadgde = microcert?.completionBadge;
  const microCertTitle = microcert?.title;

  const microCertIdNew = microcert?.certId;
  const microcertQuizQuestions = microCertDet?.questions

  console.log(microCertIdNew)


  const [trackData, setTrackData] = useState(null);
  const [microCertData, setMicroCertData] = useState(null);


  // Microcert Erro
  useEffect(() => {
    if (errorMessageDetails) {
      Swal.fire({
        title: 'Error',
        text: errorMessageDetails,
        icon: 'error',
        confirmButtonText: 'Retry',
        customClass: {
          title: 'my-custom-title-of-pop-login',
          confirmButton: 'my-custom-button-of-pop',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
    }
  }, [errorMessageDetails]); 

  // Learning Hub erros
  useEffect(() => {
    if (errorMessageData) {
      Swal.fire({
        title: 'Error',
        text: errorMessageData,
        icon: 'error',
        confirmButtonText: 'Retry',
        customClass: {
          title: 'my-custom-title-of-pop-login',
          confirmButton: 'my-custom-button-of-pop',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
    }
  }, [errorMessageData]); 


  // Handle when parameters or video URL change
  useEffect(() => {
    // Reset playing state and set new video URL
    console.log(playing)
    setPlaying(false);
  }, [microCertDet?.video]);


  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 768) {
        setScreenSize('mobile');
      } else if (width <= 1024) {
        setScreenSize('tablet');
      } else {
        setScreenSize('desktop');
      }
    };

    handleResize(); // Call on initial render
    window.addEventListener('resize', handleResize); // Add event listener for resize

    return () => {
      window.removeEventListener('resize', handleResize); // Cleanup on component unmount
    };
  }, []);

  useEffect(() => {
    setFullPageLoading(true)
    setTimeout(() => {
      setFullPageLoading(false)
    }, 3000);
  }, [])

  // useEffect(() => {
  //   if (microcert) {
  //     setIncludeTrainingVideo(microcert.videoStatus);
  //     setIncludeQuiz(microcert.questionStatus || isQuizPassed);
  //   }
  // }, [microcert, isQuizPassed]);

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when component mounts
  }, []);


  // useEffect(() => {

  //   if (completedTracks[trackId]?.[microcertId]) {
  //     alert("This microcert is already completed.");
  //   }
  // }, [trackId, microcertId, completedTracks]);



  useEffect(() => {
    if (videoStatus !== undefined) {
      setIncludeTrainingVideo(videoStatus);
    }
  }, [videoStatus]);

  useEffect(() => {
    if (quizStatus !== undefined) {
      setIncludeQuiz(quizStatus)
      setIsQuizPassed(quizStatus)

    }
  }, [quizStatus]);




  const handleTrainingVideoChange = async () => {
    if (!includeTrainingVideo) { // Only proceed if it's not already checked
      try {
        const newVideoStatus = true;
        setIncludeTrainingVideo(newVideoStatus);
        console.log(microCertIdNew)
        const result = await dispatch(updateVideoStatus(microCertIdNew, microCertTitle));

        if (!result.success) {
          console.error('Error details:', result.error);
          throw new Error('Failed to update video status');
        } else {
          dispatch(fetchLearningHub())
        }

      } catch (error) {
        console.error('Error updating video status:', error);
        setIncludeTrainingVideo(false); // Handle error case
      }
    }
  };


  const handleQuizChange = () => {
    setIncludeQuiz(!includeQuiz);
  };

  const handleShowQuizModal = () => {
    if (includeTrainingVideo) {
      setShowQuizModal(true);
    }
  };

  const handleCloseQuizModal = () => {
    setShowQuizModal(false);
  };

  const handleQuizSuccess = () => {
    setIncludeQuiz(true); // Automatically check the Quiz checkbox
    setIsQuizPassed(true);
    localStorage.setItem('quizCompleted', 'true'); // Set the state to indicate that the quiz is passed
  };


  const isCompleted = includeTrainingVideo && includeQuiz;


  const downloadBadge = () => {
    const link = document.createElement('a');
    link.href = normalizeMediaUrl(completeionBadgde, 'download');
    window.open(normalizeMediaUrl(completeionBadgde, 'download'), '_blank');
  };

  const shareOnLinkedIn = () => {
    const badgeUrl = encodeURIComponent(normalizeMediaUrl(completeionBadgde, 'image'));
    const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${badgeUrl}`;
    window.open(linkedInUrl, '_blank');
  };


  const handleContextMenu = (event) => {
    event.preventDefault(); // Prevents the context menu from appearing
  };


  const handleshowpopup = () => {
    Swal.fire({
      title: `Quiz Failed`,
      icon: 'error',
      html: `
      <table>
    <thead>
        <tr>
            <th><center>Passing Score</center></th>
            <th><center>Your Score</center></th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td><center>80</center></td>
            <td><center><strong>40</strong></center></td>
        </tr>
    </tbody>
    <p>You Got 2 Out 5 correct</p>
</table>

    `,
      confirmButtonText: 'Retry Quiz'
    }).then((swalResult) => {
      if (swalResult.isConfirmed) {

      }
    });
  }


  return (
    <>

      {isLoadingData && <LoadingScreen text="Loading.." />}

      {isLoadingDetails && <LoadingScreen text="Loading..." />}

      <BackNavbarLearning activeTabSales={"LEARNING_HUB"} />

      <div className='background-color-course'>
        <div className='container'>
          <h1 className='micro-certs-det-training-name'><span className='micro-certs-det-training-name-span'>{track?.trackTitle}</span> / {microCertDet?.title}</h1>
          <p className='micro-certs-det-training-details'>{microCertDet?.fullDescription}</p>



          <div class="row">
            <div class="col-lg-8 col-md-12">
              <div className="video-container">
                {!isLoadingDetails && microCertDet?.video ? (
                  <div className="video-wrapper" onContextMenu={handleContextMenu}>
                    <div className="custom-react-player">
                      {getMediaProvider(microCertDet?.video) === 'google-drive' ? (
                        <iframe
                          src={normalizeMediaUrl(microCertDet?.video, 'preview')}
                          title="Training video"
                          width="100%"
                          height="100%"
                          frameBorder="0"
                          allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
                          allowFullScreen
                        />
                      ) : (
                      <ReactPlayer
                        url={microCertDet?.video}
                        controls
                        playing={playing}
                        width="100%"
                        height="100%"
                        light={normalizeMediaUrl(microCertDet?.thumbnail, 'thumbnail')}
                        playIcon={
                          <button className="custom-play-button" onClick={handlePlayButtonClick}>
                            ▶️
                          </button>
                        }
                      />
                      )}
                    </div>
                  </div>
                ) : (
                  <p>Video not available</p>
                )}

              </div>
            </div>
            <div class="col-lg-4 col-md-12">
              <div className='module-details-sec'>
                <h1 className='module-details-detail' onClick={() => handleshowpopup()}>Details</h1>
                <div className='cour-dist'>
                  <p className='course-dist-det-v2'><span className='cougrse-dist-det-one'>&#8226; {microCertDet?.completionTime}</span>    <span className='course-dist-det-two'>&#8226; 1 module</span></p>
                </div>
              </div>
              <br></br>


              {!(videoStatus && quizStatus) ? (
                <div className='module-details-sec'>
                  <h1 className='module-details-detail'>Progress</h1>
                  <div className="checkbox-container">
                    <input
                      type="checkbox"
                      id="trainingVideoCheckbox"
                      checked={includeTrainingVideo}
                      onChange={handleTrainingVideoChange}
                      disabled={includeTrainingVideo}
                    />
                    <label htmlFor="trainingVideoCheckbox">Training Video</label>
                  </div>

                  {!isLoadingDetails && includeTrainingVideo && (
                    <div className='quize-btn-flex'>
                      <div className="checkbox-container">
                        <input
                          type="checkbox"
                          id="quizCheckbox"
                          checked={includeQuiz || isQuizPassed} // Automatically check if quiz is passed
                          onChange={handleQuizChange}
                          disabled={true}
                        />
                        <label htmlFor="quizCheckbox">Quiz</label>
                      </div>
                      {!isQuizPassed && (
                        <p className="start-quize-not" onClick={() => setShowQuizModal(true)}>
                          Start Quiz
                        </p>
                      )}
                    </div>
                  )}

                  {!isLoadingDetails && isCompleted ? (
                    <>
                      <button className="mark-as-complte-green" disabled={!isCompleted}>
                        Completed <span>&#10004;</span>
                      </button>
                      <br></br>
                      <button className="download-badge" disabled={!includeQuiz || !includeTrainingVideo} onClick={() => handleShowBadgdeModel()}>
                        <span><i className="fa-solid fa-certificate"></i></span> View Badge
                      </button>
                    </>
                  ) : (
                    <>
                      <br></br>
                      <div className="instructions">
                        <h2 className='module-details-detail'>Instructions</h2>
                        <ul>
                          <li className='instruction-list'>After watching the video, check the "Training Video" box.</li>
                          <li className='instruction-list'>Click "Start Quiz" to begin.</li>
                          <li className='instruction-list'>Check the "Quiz" box upon completing the quiz.</li>
                        </ul>
                      </div>
                    </>
                  )}
                </div>
              ) : (
                <div className='module-details-sec'>
                  <h1 className='module-details-detail'>Completed</h1>
                  <button className="mark-as-complte-green" disabled>
                    Completed <span>&#10004;</span>
                  </button>
                  <br></br>
                  <button className="download-badge" disabled={!includeQuiz || !includeTrainingVideo} onClick={() => handleShowBadgdeModel()}>
                    <span><i className="fa-solid fa-certificate"></i></span> View Badge
                  </button>
                </div>
              )}
            </div>
          </div>
          <br></br>
          <div>
          </div>


          {/* Micro Certs related to Narrative traings */}
          <div className='result-sec-flex'>
            <div>
              <h6>Related microcerts in {trackId}</h6>
            </div>
            <div>
              <Link to={`${PATH.LEARNING_HUB_TRACKS_PATH}${trackId}`} style={{ textDecoration: 'none' }}>
                <h6 className='see-more-content-store'>See More</h6>
              </Link>
              <div class="line"></div>
            </div>
          </div>


          <div className="row">
            {track?.microcertsList
              .filter(microcert =>
                (microcert.questionStatus === false && microcert.videoStatus === true) ||
                (microcert.questionStatus === false && microcert.videoStatus === false)
              )
              .map(microcert => {
                if (microcert.certId !== parseInt(microcertId)) {
                  return (
                    <div className="col-sm-6 col-md-4 col-lg-3" key={microcert.certId}>
                      <div className="sub-course-card">
                        <div class="course-image-micro">
                          <img src={normalizeMediaUrl(microcert.certThumnail, 'image')} alt="Course Showcase" />
                        </div>
                        <div className="sub-course-details">
                          <h2 className='sub-course-name'>{microcert.title}</h2>
                          <div className='cour-dist'>
                            <p className='sub-course-dist-det'>
                              <span className='sub-cougrse-dist-det-one'>&#8226; {microcert.completionTime}</span>
                              <span className='sub-course-dist-det-two'>&#8226; 1 Module</span>
                            </p>
                          </div>
                          <p className='sub-course-det-paragraph'>{microcert.shortDescription}</p>
                          <Link to={`${PATH.LEARNING_HUB_MICROCERTS_PATH}${trackId}/${encryptId(microcert.certId)}`}><p className="launch-button">Launch now {`>>`}</p></Link>
                        </div>
                      </div>
                    </div>
                  );
                } else {
                  return null;
                }
              })}
          </div>



          <br></br>
          <br></br>

          {/* Remainng Narrative Trainings */}
          <p className='available-tracks'>Available Tracks (2)</p>


          {AllTracks?.map((track, index) => {
            if (track?.trackTitle !== trackId) {
              return (
                <div class="course-card" key={track?.trackTitle}>
                  <div class="course-image">
                    <img src={normalizeMediaUrl(track?.thumbnail, 'image')} alt="Course Showcase" />
                  </div>
                  <div class="course-details">
                    <h1 className='training-title'>{track?.trackTitle}</h1>
                    <div class="line-lear"></div>
                    <div className='cour-dist'>
                      <p className='course-dist-det'>
                        <span className='cougrse-dist-det-one'>&#8226; {track?.totalDuration}</span>
                        <span className='course-dist-det-two'>&#8226; {track?.microcertsList.length} Microcerts</span>
                      </p>
                    </div>
                    <p className='para-lear'>{track?.trackDescription}</p>
                    <Link to={`${PATH.LEARNING_HUB_TRACKS_PATH}${track?.trackTitle}`}><p class="launch-button">Show Courses <i class="fa-solid fa-angles-right"></i></p></Link>
                  </div>
                </div>
              );
            } else {
              return null;
            }
          })}
          <br></br>
          <br></br>
        </div>
      </div>






      {/* Quize Modal */}
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
        centered
        show={showQuizModal}
        backdrop="static"
      >
        <Modal.Body className='quiz-background-top'>
          <div className='quick-assest-modal'>
            <h1 className='quick-assesstment'>Quick Assessment</h1>
            <p className='quick-assetment-p'>This questionnaire is designed to gauge your understanding and ensure you've grasped the key concepts. </p>
            <button className="close-button" onClick={handleCloseQuizModal}><span aria-hidden="true">&times;</span></button>
          </div>
          <Quiz
            questions={microcertQuizQuestions}
            certName={microCertTitle}
            id={microCertIdNew}
            onClose={() => setShowQuizModal(false)}
            onSuccess={handleQuizSuccess} />
        </Modal.Body>
      </Modal>




      {/* Badgde Model */}
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        show={badgeModel}
        onHide={() => handleCloseBadgdeModel()}
        fullscreen={false}
      >
        <Modal.Body className='badgde-body'>
          <img className='badgde-cert' src={normalizeMediaUrl(completeionBadgde, 'image')} alt="Completion badge" />
          <div className='badgde-btn'>
            <button className='download-badgde' onClick={downloadBadge}>Download Badge</button>
            <button className='share-linkdin' onClick={shareOnLinkedIn}>Share On LinkedIn</button>
          </div>
        </Modal.Body>
      </Modal>

    </>
  )
}

export default LearningHubCourse
